import qs from 'qs'
import axios from '../config/axios.js'
// let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } };
// let configV1 = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } };
const BASE_URL = '/api/college_manage'
export const analysisServer = {
  queryDirctoryList: (params) => {
    return axios.get(`${BASE_URL}/courseAnaly/queryDirctoryList`, {params: params}).then(res => res.data)
  },
  queryDirctoryInfo: (params) => {
    return axios.get(`${BASE_URL}/courseAnaly/queryDirctoryInfo`, {params: params}).then(res => res.data)
  },
  queryVideoInfo: (params) => {
    return axios.get(`${BASE_URL}/courseAnaly/queryVideoInfo`, {params: params}).then(res => res.data)
  },
  queryQuestionInfo: (params) => {
    return axios.get(`${BASE_URL}/courseAnaly/queryQuestionInfo`, {params: params}).then(res => res.data)
  },
  queryStudyInfo: (params) => {
    return axios.get(`${BASE_URL}/courseAnaly/queryStudyInfo`, {params: params}).then(res => res.data)
  },
}



// WEBPACK FOOTER //
// ./src/api/server/analysis.js